import React from 'react';
import { useTheme } from '@mui/material';
import { FornecedorData } from './types';
import DrillDownTopPartnersChart from './DrillDownTopPartnersChart';

interface DrillDownTopSuppliersChartProps {
  fornecedores: FornecedorData[];
  title?: string;
  maxItems?: number;
  height?: number;
  gridSize?: {
    xs?: number;
    md?: number;
  };
}

const DrillDownTopSuppliersChart: React.FC<DrillDownTopSuppliersChartProps> = ({
  fornecedores,
  title = "Top 10 Fornecedores do Período",
  maxItems = 10,
  height = 400,
  gridSize = { xs: 12, md: 12 }
}) => {
  const theme = useTheme();

  return (
    <DrillDownTopPartnersChart
      data={fornecedores}
      valueKey="valor_compras"
      nameKey="nome"
      indexKey="fornecedor"
      barKey="Valor Compras"
      color={theme.palette.success.main}
      title={title}
      maxItems={fornecedores.length}
      height={height}
      gridSize={gridSize}
    />
  );
};

export default DrillDownTopSuppliersChart; 